import { render } from "./StakeholderListRow.vue?vue&type=template&id=78452ed3&ts=true"
import script from "./StakeholderListRow.vue?vue&type=script&lang=ts"
export * from "./StakeholderListRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__